export default __webpack_public_path__ + "static/media/avatar.6dcde115.svg";